<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 변경목적 -->
							<th class="col-1">* {{ getMessage_('QWCC000043') }}</th>
							<td class="col-4">
								<el-input :value="detailForm.altrPurpSbc" @input="val => setDetailForm(val, 'altrPurpSbc', 150)" :readonly="overInspect" />
							</td>
							<!-- 파일첨부 -->
							<th>{{ getMessage_('QWCC000039') }}</th>
							<!-- 변경 전 사양 -->
							<th>{{ getMessage_('QWCC000044') }}</th>
							<!-- 변경 후 사양 -->
							<th>{{ getMessage_('QWCC000045') }}</th>
						</tr>
						<tr>
							<!-- 변경 내용 -->
							<th>* {{ getMessage_('QWCC000046') }}</th>
							<td>
								<el-input
									type="textarea"
									:rows="8"
									:show-word-limit="true"
									:value="detailForm.altrSbc"
									@input="val => setDetailForm(val, 'altrSbc', 550)"
									:readonly="overInspect"
								/>
							</td>
							<td class="col-3 h-100">
								<template v-if="isLoaded">
									<file-upload-list
										id="altrFile"
										ref="altrFileRef"
										width="100%"
										height="100%"
										:propFileList="detailForm.altrFileDb"
										:isEditable="!overInspect"
										maxQuantity="5"
										@MultiFile="fileUpload"
										@onDownload="onDownloadFile"
									></file-upload-list>
								</template>
							</td>
							<td rowspan="2" style="width: 100px">
								<template v-if="isLoaded">
									<img-upload
										ref="altrPreFileRef"
										width="100%"
										height="140px"
										:propSrc="altrPreFileUrl"
										propSeq="altrPreFile"
										:propFileId="detailForm.altrPreFileId"
										:disabled="isDisabled !== 2 || overInspect"
										:isEditable="!overInspect"
										@imgUpload="imgUpload"
										@imgDownload="imgDownload"
										@deleteImg="imgDelete"
										:needDupCheck="true"
										@imgDupCheck="imgDupCheck"
									>
									</img-upload>
								</template>
							</td>
							<td rowspan="2" style="width: 100px">
								<template v-if="isLoaded">
									<img-upload
										ref="altrAftFileRef"
										width="100%"
										height="140px"
										:propSrc="altrAftFileUrl"
										propSeq="altrAftFile"
										:propFileId="detailForm.altrAftFileId"
										:disabled="isDisabled === 0 || overInspect"
										:isEditable="!overInspect"
										@imgUpload="imgUpload"
										@imgDownload="imgDownload"
										@deleteImg="imgDelete"
										:needDupCheck="true"
										@imgDupCheck="imgDupCheck"
									></img-upload>
								</template>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { getLimitedByteText } from '@/qmsUtils';
import ImgUpload from '@qms/Components/ImgUpload.vue';
import FileUploadList from '@qms/Components/FileUploadList.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/Eo4mApcn/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false,
			isDisabled: 0,
			altrPreFileUrl: '',
			altrAftFileUrl: '',
			altrPreFileNm: '',
			altrAftFileNm: ''
		};
	},
	components: { ImgUpload, FileUploadList },
	computed: {
		...rootComputed,
		...serviceComputed,
		overInspect() {
			return Number(this.detailForm.pgsStCd) > 20 || !this.isWriterSelf_;
		}
	},
	async mounted() {
		await this.loadImg();
		// FL : 초도품, RC : 변경품
		if (this.detailForm.partClCd === '') this.isDisabled = 0;
		if (this.detailForm.partClCd === 'FL') this.isDisabled = 1;
		if (this.detailForm.partClCd === 'RC') this.isDisabled = 2;
	},
	watch: {
		detailForm: {
			deep: true,
			handler() {
				if (this.detailForm.partClCd === '') this.isDisabled = 0;
				if (this.detailForm.partClCd === 'FL') this.isDisabled = 1;
				if (this.detailForm.partClCd === 'RC') this.isDisabled = 2;
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async setDetailForm(value, key, maxByte) {
			this.setState_({ key: 'isSaved', value: true });
			console.log(value.length);
			maxByte ? this.setDetailForm_({ key, value: getLimitedByteText(value, maxByte) }) : this.setDetailForm_({ key, value });
		},
		imgDupCheck({ seq, file }) {
			let isDup;
			if (seq === 'altrPreFile') {
				isDup = this.altrAftFileNm == file.name;
			} else {
				isDup = this.altrPreFileNm == file.name;
			}

			if (!isDup) {
				this.$refs[seq + 'Ref'].imgUpload();
			} else {
				this.$sf_toast({ type: 'error', title: 'Warning', message: this.getMessage_('QWCC001869') }); //파일 이름이 같을 경우 업로드가 제한됩니다.
			}
		},
		imgUpload({ seq, file }) {
			this.setDetailForm_({ key: seq, value: file });
			this[seq + 'Nm'] = file.name;
		},
		fileUpload(saveList) {
			this.setDetailForm_({ key: 'altrFile', value: saveList });
		},
		imgDelete({ seq }) {
			this[seq + 'Nm'] = '';
			this.setDetailForm_({ key: seq + 'Db', value: null });
			this.setDetailForm_({ key: seq, value: null });
			this.setDetailForm_({ key: seq + 'Id', value: '' });
		},
		async imgDownload({ seq }) {
			await this.fileDownload_({ fileId: this.detailForm[seq + 'Id'], fileSeq: 1 });
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		async loadImg() {
			this.isLoaded = false;
			const { url: altrPreFileUrl } = this.detailForm.altrPreFileId
				? await this.imgDownload_({ fileId: this.detailForm.altrPreFileId, fileSeq: 1 })
				: '';
			const { url: altrAftFileUrl } = this.detailForm.altrAftFileId
				? await this.imgDownload_({ fileId: this.detailForm.altrAftFileId, fileSeq: 1 })
				: '';

			if (altrPreFileUrl) {
				this.altrPreFileUrl = altrPreFileUrl;
				this.altrPreFileNm = this.detailForm.altrPreFileDb.origFileName;
			}
			if (altrAftFileUrl) {
				this.altrAftFileUrl = altrAftFileUrl;
				this.altrAftFileNm = this.detailForm.altrAftFileDb.origFileName;
			}
			this.isLoaded = true;
		},
		initImgAll(seq) {
			//이미지 컴포넌트 초기화
			if (!seq) {
				this.altrPreFileUrl = '';
				this.altrAftFileUrl = '';
				this.$refs.altrPreFileRef?.initImg();
				this.$refs.altrAftFileRef?.initImg();
			} else {
				this[seq + 'Url'] = '';
				this[seq + 'Nm'] = '';
				this.$refs[seq + 'Ref'].initImg();
			}
		}
	}
};
</script>

<style></style>
